export default __webpack_public_path__ + "static/media/pyesu_start_overlay.e565cfaf.svg";